import { CertificateQuestion } from 'src/types/CertificateQuestion'
import { MultipleChoiceAnswers } from './MultipleChoiceAnswerTable'

export function renderQuestionAnswers(question: CertificateQuestion) {
    switch (question.type) {
        case 'multiple_choice': {
            return <MultipleChoiceAnswers question={question} />
        }
    }
}
